import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CategoryIconComponent } from './category-icon.component';

@NgModule({
  imports: [
    CommonModule,
    FontAwesomeModule
  ],
  declarations: [CategoryIconComponent],
  exports: [CategoryIconComponent]
})
export class CategoryIconModule {}
